// Browser durable replicas persist exactly the runtime/baseline event contract
// emitted by the new-sync transport. Bump this when replay envelope semantics or
// payload compaction change in a way older browser replicas must not append to.
export const NEW_SYNC_EVENT_CONTRACT_VERSION = 4;
